<template>
    <!--两个按钮-->
    <div class="row justify-content-between ">
        <div class="col">
            <router-link
                    to="/"
                    type="button"
                    class="btn nav-button btn-block"
                    :class="{ 'btn-success': $route.path === '/' || $route.path === '/search', 'btn-inactive': $route.path !== '/' && $route.path !== '/search' }"
            >
                <i class="bi bi-person"></i>  楼凤信息
            </router-link>
        </div>
        <div class="col">
            <router-link
                    to="/enter"
                    type="button"
                    class="btn nav-button btn-block"
                    :class="{ 'btn-success': $route.path === '/enter', 'btn-inactive': $route.path !== '/enter' }"
            >
                <i class="bi bi-cup"></i> 个人/商家/经纪人
            </router-link>
        </div>
    </div>
    <!--两个按钮-->
</template>
<script>
    export default {
        name: "ZhaiTwoTuttons"
    }
</script>

<style scoped>
    .row {
        display: flex;
        justify-content: space-between; /* 按钮间距 */
        align-items: center; /* 垂直居中 */
        gap: 10px; /* 按钮之间的空隙 */
    }

    .col {
        padding: 0; /* 去除列的内边距 */
    }

    .nav-button {
        width: 100%; /* 按钮铺满列 */
        padding: 5px 10px; /* 减小内边距，降低按钮高度 */
        font-size: 14px; /* 减小字体大小 */
        line-height: 1.5; /* 调整行高，进一步控制高度 */
        border-radius: 4px; /* 调整圆角 */
    }

    .btn-success {
        background-color: #18b371 !important;
        border: none !important;
    }

    .btn-inactive {
        background-color: #DDD !important;
        border: none !important;
    }
    .bi {
        margin-right: 1px; /* 图标和文字之间的间距 */
    }
</style>
